import(/* webpackMode: "eager", webpackExports: ["PageWrapper"] */ "/app/src/components/layout/page-wrapper/page-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionHeader"] */ "/app/src/components/ui/section-header/section-header.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/app/src/widgets/home/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeFaq"] */ "/app/src/widgets/home/home-faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeFinalCta"] */ "/app/src/widgets/home/home-final-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeHowItWorks"] */ "/app/src/widgets/home/home-how-it-works.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeMiniAbout"] */ "/app/src/widgets/home/home-mini-about.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeReviewPromoCta"] */ "/app/src/widgets/home/home-review-promo-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeReviewsStrip"] */ "/app/src/widgets/home/home-reviews-strip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeSocialSection"] */ "/app/src/widgets/home/home-social-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["McsList"] */ "/app/src/widgets/masterclasses/msc-list.tsx");
